export const ICON_VIEW_TYPE = {
  FIVE_COL_ICON: 'FIVE_COL_ICON',
  TWO_COL_FEATURED_ICON: 'TWO_COL_FEATURED_ICON',
} as const;

export type IconViewType = (typeof ICON_VIEW_TYPE)[keyof typeof ICON_VIEW_TYPE];

export interface IconSummaryItem {
  name: string;
  deeplink: string;
  representative_image: string;
  /** 렌더링 뷰 타입. 없으면 FIVE_COL_ICON으로 처리 (icons/summary는 미전달). */
  view_type?: IconViewType;
  /** TWO_COL_FEATURED_ICON의 부제목. nullable. */
  description?: string | null;
}

export interface IconSummary {
  item: IconSummaryItem;
  logging: {
    analytics: Record<string, unknown>;
  };
}

export interface GetIconsSummaryResponse {
  icon_list: IconSummary[];
}
